// List of all blog posts
// This file is manually maintained - add new posts here
export const blogPosts = [
  {
    title: 'Introducing CalorieX — AI-Powered Calorie Tracking',
    date: '2026-03-26',
    slug: 'introducing-caloriex',
    description: 'CalorieX is a new calorie tracking app that uses AI to log meals from natural language, photos, and barcodes. Available now on the App Store.',
    tags: ['CalorieX', 'iOS', 'AI', 'Launch'],
    icon: '/caloriex/images/app-icon.png'
  },
  {
    title: 'Your WorkerFactory could throw ClassNotFoundException if you rename, move or delete your Worker classes',
    date: '2019-11-10',
    slug: 'workerfactory-classnotfoundexception',
    description: 'A common pitfall when using custom WorkerFactory with Dagger in Android WorkManager',
    tags: ['Android', 'WorkManager', 'Dagger']
  }
];
